import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Type from './Type';
import { fetchTypes } from 'store/type/typesActions';

class TypeContainer extends React.Component {
    componentDidMount() {
        this.props.fetchTypes();
    }

    render() {
        const { type, isLoading } = this.props;


        return (
            <Type
                type={type}
                isLoading={isLoading}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    type: state.type.types.items.find(x => x.id === ownProps.typeId),
    isLoading: state.type.types.isLoading
});


const mapDispatchToProps = {
    fetchTypes
};

TypeContainer.propTypes = {
    typeId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(TypeContainer);